import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import classNames from 'classnames';
import PageHeader from '../../../components/base/PageHeader/PageHeader';
import {
  Button, Icons,
} from '../../../components/base/BootstrapComponents';
import TabMenu from '../../../components/base/TabMenu/TabMenu';
import TextInput from '../../../components/fields/TextInput/TextInput';
import FieldWithAttributeDTO from '../../../components/fields/Abstract/FieldWithAttributeDTO';
import { optionClassFormatter } from '../../../utils/formatters';
import { cMetricKeys, CAMERA_STATUS } from '../constants';

import { getParkingMetersData } from '../../ParkingMeter/reducer';
import { getCamerasData } from '../reducer';

import {
  getPaginationOpts, responseLogWithNotification, saveFilter,
} from '../../../utils/utils';
import Loader from '../../../components/base/Loader/Loader';
import { convertMetricFilters, sortByStatus } from '../camera-utils';
import MobileCamerasFilter from './MobileCamerasFilter';
import MobileCamerasGrid from './MobileCamerasGrid';
import MobileCamerasHistoryPopup from './MobileCamerasHistoryPopup';
import MobileCamerasMap from './MobileCamerasMap';
import MobileCamerasMatrix from './MobileCamerasMatrix';
import MatrixReportPopup from './MatrixReportPopup';
import RadioButton from '../../../components/fields/RadioButton/RadioButton';
import RadioList from '../../../components/fields/CheckBoxInput/RadioList';
import { loadCamerasList, loadCamerasStatusesList } from '../actions';
import CameraDTO from '../../../dto/CameraDTO';

const tabOptions = [
  { value: 0, label: 'Таблица' },
  { value: 1, label: 'Карта' },
  { value: 2, label: 'Матрица' },
];

export default function MobileCamerasPage() {
  const {
    loadingHostComponents,
    showHistoryPopup,
    currentParkingMeter,
    loadingHostCommandDispatch,
    loadingHostDetail,
    hostDetail,
    loadingHistoryExportWord,
    zones,
    loadingZones,
  } = useSelector(getParkingMetersData);

  const {
    loadingCamerasList,
    camerasList,
    camerasListMeta,
    loadingCamerasStatusesList,
    camerasStatusesList,
    camerasStatusesListMeta,
  } = useSelector(getCamerasData);

  const dispatch = useDispatch();
  const handleLoadingHostList = opts => {
    const filterData = getValues();
    if (opts && !opts.page) {
      opts.page = 1;
    }
    Object.keys(filterData).forEach(key => {
      if (!filterData[key]) {
        delete filterData[key];
      }
    });
    saveFilter(filterData, 'cameras-filter');
    if (filterData) {
      convertMetricFilters(filterData);
    }
    const paginationOpts = getPaginationOpts(camerasListMeta, opts);
    const requestData = { metricKeys: cMetricKeys, ...paginationOpts, filter: filterData };
    const action = !selectedTab || !selectedTab.value
      ? loadCamerasList
      : loadCamerasStatusesList;
    if (currentTimeOut) {
      clearTimeout(currentTimeOut);
    }
    if (window.location.pathname === '/cameras') {
      dispatch(action(requestData)).catch(responseLogWithNotification).finally(() => {
        if (updatePeriod && selectedTab) {
          const t = setTimeout(() => handleLoadingHostList(opts), updatePeriod * 1000);
          clearTimeout(window.camerasTimeOut);
          window.camerasTimeOut = t;
        }
        setShowContent(true);
      // setOpenFilter(false);
      });
    }
  };
  const [selectedTab, setTab] = useState(tabOptions[0]);
  const [selectedHost, setHost] = useState(null);
  const [isOpenFilter, setOpenFilter] = useState(false);
  const [fullScreen, setFullScreenMap] = useState(false);
  const defaultValues = {
    query: '',
    name: '',
    status: null,
    address: '',
    zbx_zone: '',
    update_period: 0,
    available_status: null,
    DS_ERROR: false,
    DS_NO_INIT_DETECT_VIOLATION: false,
    DS_NO_INIT_DETECTION: false,
    DS_NO_INIT_CAMERA: false,
    DS_UNKNOWN: false,
    DS_OK: false,
    PRS_NO: false,
    PRS_UNKNOWN: false,
    PRS_YES: false,
  };

  const {
    register, watch, getValues, setValue, reset, resetField,
  } = useForm({
    defaultValues: { ...defaultValues, ...(JSON.parse(localStorage.getItem('cameras-filter')) || {}) },
  });

  watch();

  useEffect(() => {
    const subscription = watch(value => {
      if (!getValues('update_period')) {
        setUpdatePeriod(0);
      }
      if (isOpenFilter) {
        handleLoadingHostList();
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);
  const [showContent, setShowContent] = useState(false);
  const [updatePeriod, setUpdatePeriod] = useState(0 || getValues('update_period'));
  const [zoom, setZoom] = useState(10);
  const [currentTimeOut, setCurrentTimeOut] = useState(null);
  const [showMatrixReport, setShowMatrixReport] = useState(false);
  const [isCenter, setIsCenter] = useState(false);
  const isInitialMount = useRef(true);
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      handleLoadingHostList();
      return () => { clearTimeout(window.camerasTimeOut); };
    }
  }, [selectedTab, updatePeriod]);

  const statusOptions = Object.values(CAMERA_STATUS).map(v => ({ value: Number(v), nameId: `cameras.status.${v}` })).reverse();
  const DTO = new CameraDTO();
  const attributes = DTO.getAttributesByName();
  const triggerFullScreen = value => setFullScreenMap(value);
  const changeUpdatePeriod = value => {
    setUpdatePeriod(value || 0);
  };
  const sortedHostStatusesList = camerasStatusesList.sort(sortByStatus);

  const showOnMap = item => {
    setTab(tabOptions[1]);
    setHost(item);
  };
  const selectedStatus = statusOptions.find(i => i.value === Number(getValues('status')));
  return (
    <div className={classNames('parking-meters-page content g-0', { 'page-with-map-fullscreen': fullScreen })} id="parking-meter-scroll-block-1">
      <Loader global loading={loadingZones || loadingCamerasList || loadingHostComponents || loadingHostCommandDispatch || loadingCamerasStatusesList || loadingHostDetail || loadingHistoryExportWord} />
      {showContent
        ? (
          <div className="mobile-parking-meters-content">
            <TabMenu
              selectedTab={selectedTab}
              options={tabOptions}
              onSelectOptions={item => { setTab(item); setHost(null); }}
            />
            <PageHeader className="mobile-page-header" header="Информация о видеокамерах">
              <Icons width={14} height={14} customIcon icon="filter" className="show-filter-button" onClick={() => { setOpenFilter(true); setHost(null); }} />
            </PageHeader>
            {selectedTab && selectedTab.value === 0 ? <MobileCamerasGrid loading={loadingCamerasList} showOnMap={showOnMap} hostList={camerasList} handleLoadingHostList={handleLoadingHostList} hostListMeta={camerasListMeta} /> : null}
            {selectedTab && selectedTab.value === 1 && window.yandexMap ? <MobileCamerasMap setHost={setHost} selectedHost={selectedHost} hostDetail={hostDetail} triggerFullScreen={triggerFullScreen} hostStatusesList={camerasStatusesList} handleLoadingHostList={handleLoadingHostList} hostListMeta={camerasListMeta} zoom={zoom} setZoom={setZoom} isCenter={isCenter} setIsCenter={setIsCenter} /> : null}
            {selectedTab && selectedTab.value === 2 ? <MobileCamerasMatrix hostDetail={hostDetail} hostStatusesList={camerasStatusesList} handleLoadingHostList={handleLoadingHostList} hostListMeta={camerasListMeta} createReport={() => setShowMatrixReport(true)} /> : null}
            {showHistoryPopup && currentParkingMeter ? <MobileCamerasHistoryPopup key={currentParkingMeter && currentParkingMeter.id ? currentParkingMeter.id : ''} /> : null}
            {showMatrixReport && sortedHostStatusesList ? <MatrixReportPopup sortedHostStatusesList={sortedHostStatusesList} handleClose={() => setShowMatrixReport(false)} /> : null}
          </div>
        )
        : (
          <div className="mobile-parking-meters-filter">
            <PageHeader className="mobile-page-header" header="Информация о видеокамерах" />
            <div className="mpm-filter-button">
              <span onClick={() => setOpenFilter(true)}>Все фильтры</span>
            </div>
            <FieldWithAttributeDTO
              type="text"
              component={TextInput}
              withLabel
              dtoObject={{
                name: 'query',
                type: String,
                validators: [],
                labelKey: 'search',
              }}
              inputProps={{
                ...register('query', { maxLength: 30 }),
                value: getValues('query'),
              }}
              className="search-field"
              variant="material"
            />
            <FieldWithAttributeDTO
              type="text"
              component={TextInput}
              dtoObject={attributes.host}
              withLabel
              inputProps={{
                ...register('host'),
                value: getValues('host'),
              }}
              className="host-filter"
              variant="material"
            />

            <RadioList label="Состояние" selectedValue={selectedStatus} clearFilter={() => reset({ ...getValues(), status: 0 })} filter={getValues()}>
              <FieldWithAttributeDTO
                type="text"
                component={RadioButton}
                dtoObject={attributes.status}
                className="mt-4"
                withLabel
                addPlaceholder
                options={statusOptions}
                optionClassFormatter={optionClassFormatter}
                inputProps={{
                  ...register('status'),
                  value: Number(getValues('status')),
                  onChange: e => {
                    setValue('status', Number(e.target.value));
                  },
                }}
              />
            </RadioList>
            <Button className="mpm-filter-show-list-button big" onClick={handleLoadingHostList}>Показать</Button>
          </div>
        )}

      {isOpenFilter ? (
        <MobileCamerasFilter
          handleLoadingHostList={handleLoadingHostList}
          changeUpdatePeriod={changeUpdatePeriod}
          updatePeriod={updatePeriod}
          meta={!selectedTab || !selectedTab.value ? camerasListMeta : camerasStatusesListMeta}
          reset={reset}
          onHide={() => { setOpenFilter(false); }}
          register={register}
          getValues={getValues}
          setValue={setValue}
          resetField={resetField}
          zones={zones}
          defaultValues={defaultValues}
        />
      )
        : null}
    </div>
  );
}
